module.exports = __webpack_public_path__ + "static/img/barra_8.324384c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_8.png
// module id = BdVc
// module chunks = 1